import type { ReactNode } from 'react';

export const symbol_infrared: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M642.5-328Q615-257 566-200q-8 10-21 11t-22-8q-9-9-8.5-21.5T523-241q41-48 64-109t23-130q0-69-23-130t-64-109q-8-10-8.5-22.5T523-763q9-9 22-8t21 11q49 57 76.5 128T670-480q0 81-27.5 152Zm-111-46Q513-324 480-284q-8 10-20.5 10.5T438-282q-9-9-9-21.5t8-22.5q25-32 39-71t14-83q0-44-14-83t-39-71q-8-10-8-22.5t9-21.5q9-9 21.5-8.5T480-676q33 40 51.5 90T550-480q0 56-18.5 106ZM420-419.5Q410-391 393-368q-7 10-19 10t-21-9q-9-9-9.5-21t6.5-23q10-15 15-32.5t5-36.5q0-19-5-36.5T350-549q-7-11-6.5-23t9.5-21q9-9 21-9t19 10q17 23 27 51.5t10 60.5q0 32-10 60.5Zm-130.5-11Q269-410 240-410v220q0 13-8.5 21.5T210-160q-13 0-21.5-8.5T180-190v-580q0-13 8.5-21.5T210-800q13 0 21.5 8.5T240-770v220q29 0 49.5 20.5T310-480q0 29-20.5 49.5Z"
		/>
	</svg>
);
